import { Record, OrderedSet, Map as ImmutableMap, RecordOf } from 'immutable';
import { DateTime } from 'luxon';

export type AppStoreProps = {
  sessionStartedAt: string | null;
  storeCreatedAt: string | null;
  isOffline: boolean;
  serviceWorkerIsRegistered: boolean;
  serviceWorkerIsRegistering: boolean;
  serviceWorkerUpdateIsAvailable: boolean;
  awaitingToAutoRefresh: boolean;
  updateAllFailed?: boolean;
  updateAllMessages?: OrderedSet<string>;
  isSanitized?: boolean;
  csvImportCompleteByClientId?: ImmutableMap<string, any>;
  csvImportErrorByClientId?: ImmutableMap<string, any>;
  dbUpdateTrigger?: boolean;
  fetchInProgress?: boolean;
};

export type AppStore = RecordOf<AppStoreProps>;

export const mkAppStore = Record<AppStoreProps>({
  sessionStartedAt: DateTime.utc().toISO(),
  storeCreatedAt: DateTime.utc().toISO(),
  isOffline: false,
  serviceWorkerIsRegistered: false,
  serviceWorkerIsRegistering: false,
  serviceWorkerUpdateIsAvailable: false,
  awaitingToAutoRefresh: false,
  updateAllFailed: undefined,
  updateAllMessages: undefined,
  isSanitized: undefined,
  csvImportCompleteByClientId: ImmutableMap(),
  csvImportErrorByClientId: ImmutableMap(),
  dbUpdateTrigger: undefined, // dev only hack to trigger DB updates for wdyr
  fetchInProgress: undefined,
});
